import type { EmbarcacaoDetailSection } from "../embarcacao-detail-section";
import { BaseTecnicaSection } from "./base-tecnica-section";
import {
  BASE_TECNICA_ID,
  BASE_TECNICA_TITLE,
} from "./base-tecnica-section/base-tecnica-section.constants";
import { ClasseSection } from "./classe-section";
import { CLASSE_ID, CLASSE_TITLE } from "./classe-section/classe-section.constants";
import { ComercialSection } from "./comercial-section";
import { COMERCIAL_ID, COMERCIAL_TITLE } from "./comercial-section/comercial-section.constants";
import { DimensoesPrincipaisSection } from "./dimensoes-principais-section";
import {
  DIMENSOES_PRINCIPAIS_ID,
  DIMENSOES_PRINCIPAIS_TITLE,
} from "./dimensoes-principais-section/dimensoes-principais-section.constants";
import { TanquesSection } from "./tanques-section";
import { TANQUES_ID, TANQUES_TITLE } from "./tanques-section/tanques-section.constants";
import { ConsumoOperacaoSection } from "./consumo-operacao-section";
import {
  CONSUMO_OPERACAO_ID,
  CONSUMO_OPERACAO_TITLE,
} from "./consumo-operacao-section/consumo-operacao-section.constants";
import { AcomodacoesSection } from "./acomodacoes-section";
import {
  ACOMODACOES_ID,
  ACOMODACOES_TITLE,
} from "./acomodacoes-section/acomodacoes-section.constants";
import { VazaoBombasSection } from "./vazao-bombas-section";
import {
  VAZAO_BOMBAS_ID,
  VAZAO_BOMBAS_TITLE,
} from "./vazao-bombas-section/vazao-bombas-section.constants";
import { SistemasDpSection } from "./sistemas-dp-section";
import {
  SISTEMAS_DP_ID,
  SISTEMAS_DP_TITLE,
} from "./sistemas-dp-section/sistemas-dp-section.constants";
import { MotoresSection } from "./motores-section";
import { MOTORES_ID, MOTORES_TITLE } from "./motores-section/motores-section.constants";
import { PropulsaoSection } from "./propulsao-section";
import { PROPULSAO_ID, PROPULSAO_TITLE } from "./propulsao-section/propulsao-section.constants";
import { ThrustersSection } from "./thrusters-section";
import { THRUSTERS_ID, THRUSTERS_TITLE } from "./thrusters-section/thrusters-section.constants";
import { EquipamentosSection } from "./equipamentos-section";
import {
  EQUIPAMENTOS_ID,
  EQUIPAMENTOS_TITLE,
} from "./equipamentos-section/equipamentos-section.constants";
import { GuinchosGuindastesSection } from "./guinchos-guindastes-section";
import {
  GUINCHOS_GUINDASTES_ID,
  GUINCHOS_GUINDASTES_TITLE,
} from "./guinchos-guindastes-section/guinchos-guindastes-section.constants";
import { VelocidadeConsumoSection } from "./velocidade-consumo-section";
import {
  VELOCIDADE_CONSUMO_ID,
  VELOCIDADE_CONSUMO_TITLE,
} from "./velocidade-consumo-section/velocidade-consumo-section.constants";
import { ContatosSection } from "./contatos-section";
import { CONTATOS_ID, CONTATOS_TITLE } from "./contatos-section/contatos-section.constants";
import { ImagensSection } from "./imagens-section";
import { IMAGENS_ID, IMAGENS_TITLE } from "./imagens-section/imagens-section.constants";

export const EMBARCACAO_DETAIL_SECTIONS: EmbarcacaoDetailSection[] = [
  { id: BASE_TECNICA_ID, title: BASE_TECNICA_TITLE, Component: BaseTecnicaSection },
  { id: CLASSE_ID, title: CLASSE_TITLE, Component: ClasseSection },
  { id: COMERCIAL_ID, title: COMERCIAL_TITLE, Component: ComercialSection },
  {
    id: DIMENSOES_PRINCIPAIS_ID,
    title: DIMENSOES_PRINCIPAIS_TITLE,
    Component: DimensoesPrincipaisSection,
  },
  { id: SISTEMAS_DP_ID, title: SISTEMAS_DP_TITLE, Component: SistemasDpSection },
  { id: MOTORES_ID, title: MOTORES_TITLE, Component: MotoresSection },
  { id: PROPULSAO_ID, title: PROPULSAO_TITLE, Component: PropulsaoSection },
  { id: THRUSTERS_ID, title: THRUSTERS_TITLE, Component: ThrustersSection },
  {
    id: GUINCHOS_GUINDASTES_ID,
    title: GUINCHOS_GUINDASTES_TITLE,
    Component: GuinchosGuindastesSection,
  },
  { id: EQUIPAMENTOS_ID, title: EQUIPAMENTOS_TITLE, Component: EquipamentosSection },
  {
    id: VELOCIDADE_CONSUMO_ID,
    title: VELOCIDADE_CONSUMO_TITLE,
    Component: VelocidadeConsumoSection,
  },
  { id: CONSUMO_OPERACAO_ID, title: CONSUMO_OPERACAO_TITLE, Component: ConsumoOperacaoSection },
  { id: TANQUES_ID, title: TANQUES_TITLE, Component: TanquesSection },
  { id: VAZAO_BOMBAS_ID, title: VAZAO_BOMBAS_TITLE, Component: VazaoBombasSection },
  { id: ACOMODACOES_ID, title: ACOMODACOES_TITLE, Component: AcomodacoesSection },
  { id: CONTATOS_ID, title: CONTATOS_TITLE, Component: ContatosSection },
  { id: IMAGENS_ID, title: IMAGENS_TITLE, Component: ImagensSection },
];

export { BaseTecnicaSection } from "./base-tecnica-section";
export {
  BASE_TECNICA_ID,
  BASE_TECNICA_LOADING_MESSAGE,
  BASE_TECNICA_TITLE,
} from "./base-tecnica-section/base-tecnica-section.constants";
export { ClasseSection } from "./classe-section";
export {
  CLASSE_ID,
  CLASSE_LOADING_MESSAGE,
  CLASSE_TITLE,
} from "./classe-section/classe-section.constants";
export { ComercialSection } from "./comercial-section";
export {
  COMERCIAL_ID,
  COMERCIAL_LOADING_MESSAGE,
  COMERCIAL_TITLE,
} from "./comercial-section/comercial-section.constants";
export { DimensoesPrincipaisSection } from "./dimensoes-principais-section";
export {
  DIMENSOES_PRINCIPAIS_ID,
  DIMENSOES_PRINCIPAIS_LOADING_MESSAGE,
  DIMENSOES_PRINCIPAIS_TITLE,
} from "./dimensoes-principais-section/dimensoes-principais-section.constants";
export { TanquesSection } from "./tanques-section";
export {
  TANQUES_ID,
  TANQUES_LOADING_MESSAGE,
  TANQUES_TITLE,
} from "./tanques-section/tanques-section.constants";
export { ConsumoOperacaoSection } from "./consumo-operacao-section";
export {
  CONSUMO_OPERACAO_ID,
  CONSUMO_OPERACAO_LOADING_MESSAGE,
  CONSUMO_OPERACAO_TITLE,
} from "./consumo-operacao-section/consumo-operacao-section.constants";
export { AcomodacoesSection } from "./acomodacoes-section";
export {
  ACOMODACOES_ID,
  ACOMODACOES_LOADING_MESSAGE,
  ACOMODACOES_TITLE,
} from "./acomodacoes-section/acomodacoes-section.constants";
export { ImagensSection } from "./imagens-section";
export {
  IMAGENS_ID,
  IMAGENS_LOADING_MESSAGE,
  IMAGENS_TITLE,
} from "./imagens-section/imagens-section.constants";
export { VazaoBombasSection } from "./vazao-bombas-section";
export {
  VAZAO_BOMBAS_ID,
  VAZAO_BOMBAS_LOADING_MESSAGE,
  VAZAO_BOMBAS_TITLE,
} from "./vazao-bombas-section/vazao-bombas-section.constants";
export { SistemasDpSection } from "./sistemas-dp-section";
export {
  SISTEMAS_DP_ID,
  SISTEMAS_DP_LOADING_MESSAGE,
  SISTEMAS_DP_TITLE,
} from "./sistemas-dp-section/sistemas-dp-section.constants";
export { MotoresSection } from "./motores-section";
export {
  MOTORES_ID,
  MOTORES_LOADING_MESSAGE,
  MOTORES_TITLE,
} from "./motores-section/motores-section.constants";
export { PropulsaoSection } from "./propulsao-section";
export {
  PROPULSAO_ID,
  PROPULSAO_LOADING_MESSAGE,
  PROPULSAO_TITLE,
} from "./propulsao-section/propulsao-section.constants";
export { ThrustersSection } from "./thrusters-section";
export {
  THRUSTERS_ID,
  THRUSTERS_LOADING_MESSAGE,
  THRUSTERS_TITLE,
} from "./thrusters-section/thrusters-section.constants";
export { EquipamentosSection } from "./equipamentos-section";
export {
  EQUIPAMENTOS_ID,
  EQUIPAMENTOS_LOADING_MESSAGE,
  EQUIPAMENTOS_TITLE,
} from "./equipamentos-section/equipamentos-section.constants";
export { GuinchosGuindastesSection } from "./guinchos-guindastes-section";
export {
  GUINCHOS_GUINDASTES_ID,
  GUINCHOS_GUINDASTES_LOADING_MESSAGE,
  GUINCHOS_GUINDASTES_TITLE,
} from "./guinchos-guindastes-section/guinchos-guindastes-section.constants";
export { VelocidadeConsumoSection } from "./velocidade-consumo-section";
export {
  VELOCIDADE_CONSUMO_ID,
  VELOCIDADE_CONSUMO_LOADING_MESSAGE,
  VELOCIDADE_CONSUMO_TITLE,
} from "./velocidade-consumo-section/velocidade-consumo-section.constants";
export { ContatosSection } from "./contatos-section";
export {
  CONTATOS_ID,
  CONTATOS_LOADING_MESSAGE,
  CONTATOS_TITLE,
} from "./contatos-section/contatos-section.constants";
